interface PipelineStages {
  analyze: boolean
  normalize: boolean
  classify: boolean
  embed_jina: boolean
  embed_colpali: boolean | null
  embed_faces: boolean | null
  caption: boolean
  tags: boolean
  indexed: boolean
}

const STAGE_LABELS: { key: keyof PipelineStages; label: string; short: string }[] = [
  { key: 'analyze', label: 'Analyze', short: 'A' },
  { key: 'normalize', label: 'Normalize', short: 'N' },
  { key: 'classify', label: 'Classify', short: 'C' },
  { key: 'embed_jina', label: 'Jina Embed', short: 'E' },
  { key: 'embed_colpali', label: 'ColPali', short: 'P' },
  { key: 'embed_faces', label: 'Faces', short: 'F' },
  { key: 'caption', label: 'Caption', short: 'Ca' },
  { key: 'tags', label: 'Tags', short: 'T' },
]

interface PipelineIndicatorProps {
  stages: PipelineStages
}

function PipelineIndicator({ stages }: PipelineIndicatorProps) {
  return (
    <div className="flex items-center gap-1">
      {STAGE_LABELS.map(({ key, label }) => {
        const value = stages[key]
        // null = not applicable for this file type
        if (value === null) {
          return (
            <span
              key={key}
              title={`${label}: N/A`}
              className="w-2.5 h-2.5 rounded-full bg-secondary/50 cursor-help"
            />
          )
        }
        return (
          <span
            key={key}
            title={`${label}: ${value ? 'Complete' : 'Pending'}`}
            className={`w-2.5 h-2.5 rounded-full cursor-help ${
              value
                ? 'bg-green-500'
                : 'border border-muted-foreground/40 bg-transparent'
            }`}
          />
        )
      })}
    </div>
  )
}

export default PipelineIndicator
export type { PipelineStages }
